import React from 'react';

/*
 * One tutorial slide. Console typography: 19px bold title and 13px --ui-text-3 body, the
 * same pair SectionHeader uses, instead of the 24px/undersized-grey it had. The screenshot
 * sits in a bordered frame rather than floating on the panel — without the hairline, a
 * screenshot of this app on a surface of this app had no edge at all.
 */
export const TutorialStep = ({ title, description, image }) => (
  <div className="p-5 md:p-6">
    <h2 className="text-[19px] font-bold leading-tight text-ui">{title}</h2>
    <p className="mt-1.5 whitespace-pre-wrap text-[13px] leading-relaxed text-ui-3">{description}</p>

    <div className="mt-4 overflow-hidden rounded-chip border border-ui-hair-2 bg-ui-sunken">
      <img src={image} alt={title} className="block aspect-video w-full object-cover" />
    </div>
  </div>
);
